import { useMemo, useState } from "react";
// import axios from 'axios';
import Select from "react-select";
import _ from "lodash";
import { connect } from "react-redux";
import { Actions as ACTIONS } from "../../store/actions/payrollActions";
import { Actions as ALLOWANCEACTIONS } from "../../store/actions/allowanceActions";
import { Actions as OVERTIMEACTIONS } from "../../store/actions/overtimeActions";
import { Actions as DEPARTMENTACTIONS } from "../../store/actions/departmentActions";

import EmployeeRow from "./EmployeeRow";
import Spinner from "../common/Spinner";
import { ExclamationTriangleIcon, ClockIcon, ChevronDownIcon } from "@heroicons/react/20/solid";
import Tooltip from "@/tooltip";

const PayrollTable = ({
	employees,
	employeesNotReady,
	employeesNotProcessed,
	department,
	noDepartment,
	all,
	setPayrollDepartmentExpanded,
	payrollSaveAll,
	processTimesheets,
	totalEmployees,
	currency,
	isDemo,
	generating,
	expand,
	plan,
	userEntersData,
	canProcessTimesheets,
}) => {
	const [ignoreNotProcessed, setIgnoreNotProcessed] = useState(false);
	// const [expand, setExpanded] = useState(!department);

	const departmentEmployees = useMemo(() => {
		const filtered = _.orderBy(
			employees.filter(
				(employee) =>
					employee.employmentTypeName !== "External Contractor" &&
					(all ||
						(department && employee.department == department.id) ||
						(!employee.department && noDepartment)),
				// TODO REMOVE EMPLOYEE FILTER
				// && employee.employee == 256451
			),
			["fullName"],
			["asc"],
		);

		// console.log('employeesDEP',employees,department,noDepartment,filtered)
		return filtered;
	}, [department, employees]);

	if (departmentEmployees.length == 0) {
		return null;
	}

	const percentReady = ((totalEmployees - employeesNotReady) * 100) / totalEmployees;

	// console.log("percentReady",percentReady,totalEmployees,employeesNotReady,totalEmployees-employeesNotReady)

	return (
		<div
			className="block-content"
			style={{
				backgroundColor: "#f4f4f4",
				borderRadius: 10,
				padding: "15px 20px",
				margin: "15px 0",
			}}
		>
			{(department || noDepartment) && (
				<div
					className="block-header"
					style={{ padding: 0 }}
				>
					<h3
						className="block-title"
						onClick={() => setPayrollDepartmentExpanded(department?.id || "noDepartment", !expand)}
						style={{ cursor: "pointer" }}
					>
						{department?.name}
						{noDepartment ? "Employees without Department" : ""}

						<ChevronDownIcon
							style={{
								minWidth: "2.25rem",
								width: "2.25rem",
								marginLeft: 10,
								marginRight: 10,
								verticalAlign: "text-bottom",
								cursor: "pointer",
								display: "inline-block",
								textAlign: "center",
								transform: expand ? "rotate(180deg)" : "rotate(0deg)",
								transition: "transform 0.2s ease-in-out",
							}}
						/>
					</h3>
					{!userEntersData && employeesNotProcessed > 0 && (
						<div
							className="btn btn-success pull-right"
							disabled={!canProcessTimesheets && !isDemo}
							onClick={() => {
								if (!canProcessTimesheets && !isDemo) return;
								processTimesheets(department.id);
							}}
						>
							<Tooltip
								content="This feature is not available on your plan."
								isOpen={!canProcessTimesheets && !isDemo ? undefined : false}
							>
								<ClockIcon className="h-6 w-6 media-middle" /> Process Timesheets (
								{employeesNotProcessed})
								{false && (
									<Spinner
										style={{
											width: "2rem",
											height: "2rem",
											verticalAlign: "middle",
											marginTop: 20,
										}}
										className="animate-spin -ml-1 mr-3 h-5 w-5 text-success right"
									/>
								)}
							</Tooltip>
						</div>
					)}
				</div>
			)}
			{expand && (
				<div
					className="table-responsive table-responsive-payroll"
					style={{ backgroundColor: "#fff", marginBottom: 0, marginTop: 15 }}
				>
					<div
						className="js-table-sections table table-hover"
						style={{ marginBottom: 5 }}
					>
						<div>
							<div
								style={{
									display: "grid",
									gridGap: "1.5rem",
									grid: "1.5rem",
									gridTemplateColumns: "repeat(6, minmax(0, 1fr))",
									lineHeight: "38px",
									padding: "0px 15px 0px 45px",
									borderBottom: "1px solid #bbbcbc",
								}}
							>
								<div
									style={{ gridColumn: "span 1 / span 6" }}
									className="font-w600"
								>
									Name
								</div>
								<div
									style={{ gridColumn: "span 1 / span 6" }}
									className="font-w600"
								>
									Employment Type
								</div>
								<div
									style={{ gridColumn: "span 1 / span 6" }}
									className="font-w600"
								>
									Salary
								</div>

								{/*<span>{currency}<span className="base-pay" data-amount="4,347.12">{basePay}</span></span>*/}
								<div style={{ gridColumn: "span 1 / span 6" }}>
									<span className="font-w600">Gross Pay</span>
								</div>
							</div>
							{/*<tr>
                  <th className="text-center"></th>
                  <th id="name">Name</th>
                  <th>Employment</th>
                  <th>Salary</th>
                  <th>Base Pay Due</th>
                  <th data-toggle="tooltip" data-placement="top" title="" type="button" data-original-title="Total">Gross Pay</th>
                  <th className="text-center" id="plus" style={{width: "10%"}}></th>
                  <th>
                    <label className="css-input css-checkbox css-checkbox-primary remove-margin-t remove-margin-b">
                      <input type="checkbox" id="check-all" name="check-all"/><span></span>All
                    </label>
                  </th>
                </tr>*/}
						</div>

						{/* employee={employee}*/}

						{departmentEmployees.map((employee, index) => (
							<EmployeeRow
								employeeID={employee.id}
								key={employee.id}
								rowNo={index}
							/>
						))}
					</div>
				</div>
			)}

			{department && !userEntersData &&
				!ignoreNotProcessed &&
				employeesNotProcessed > 0 &&
				canProcessTimesheets && (
					<div
						className="alert alert-warning clearfix"
						style={{ color: "#232a32", marginTop: 15 }}
					>
						<ExclamationTriangleIcon
							className="media-middle"
							style={{ minWidth: "2.25rem", width: "2.25rem", verticalAlign: "top", marginRight: "10px" }}
						/>
						{employeesNotProcessed} of {totalEmployees} employee{totalEmployees > 0 && "s"} have not been
						processed. Make sure that you've processed timesheets before proceeding to generate payslips.
						Not processing timesheets before generating payslips may have adverse effects.
						<div
							className={`btn btn-warning pull-right`}
							style={{}}
							onClick={() => {
								setIgnoreNotProcessed(true);
							}}
						>
							I want to proceed anyway
						</div>
					</div>
				)}

			{department && !userEntersData &&
				(ignoreNotProcessed || employeesNotProcessed == 0 || !canProcessTimesheets) &&
				employeesNotReady > 0 && (
					<div
						className="alert alert-warning clearfix"
						style={{ color: "#232a32", marginTop: 15 }}
					>
						<ExclamationTriangleIcon
							className="media-middle"
							style={{ minWidth: "2.25rem", width: "2.25rem", verticalAlign: "top", marginRight: "10px" }}
						/>
						{employeesNotReady} of {totalEmployees} employee{totalEmployees > 0 && "s"} have not been
						locked. When all the locks turn green, you have processed payroll for all your team. If specific
						employees did not work this period, you can choose to proceed regardless. However no payslip
						will be issued for the individual.
						{generating && (
							<span
								className={`pull-right`}
								style={{
									minWidth: "200px",
									backgroundColor: "#fff",
									maxWidth: "200px",
									marginLeft: "10px",
									position: "relative",
								}}
							>
								<span
									style={{
										transition: "transform 0.2s ease-in-out",
										position: "absolute",
										backgroundColor: "#ea611c",
										width: `${percentReady}%`,
										height: "100%",
										left: "0",
									}}
								></span>
							</span>
						)}
						{!generating && (
							<span
								className={`btn btn-warning pull-right`}
								style={{ minWidth: "200px", maxWidth: "200px", marginLeft: "10px" }}
								onClick={() => {
									payrollSaveAll(department.id);
								}}
							>
								Generate Remaining Payslips
							</span>
						)}
					</div>
				)}
		</div>
	);
};

const mapStateToProps = (state, ownProps) => {
	const department = ownProps.department;

	const payPeriodDetails = state.payroll && state.payroll.payPeriodDetails;

	const employees = state.payroll?.employees?.filter?.((e) =>
		e.salaries.find(
			(s) =>
				!s.paySchedule ||
				(payPeriodDetails &&
					[payPeriodDetails.paySchedule, String(payPeriodDetails.payPeriods)].includes(
						String(s.paySchedule),
					)),
		),
	);
	const { isAdmin } = state?.my?.profile || {};

	const managedByAdvisor = !!state?.company?.settings?.advisor;
	const clientEntersPayrollData = state?.company?.settings?.clientEntersPayrollData;
	const userIsAdvisor = state?.my?.profile?.advisorId === state.company?.settings?.advisor || isAdmin;
	const userIsClient = !managedByAdvisor || !userIsAdvisor;
	const userEntersData = userIsClient && clientEntersPayrollData;
	// console.log('employeesDEP orig',employees,state.payroll.employees,payPeriodDetails?.paySchedule)

	return {
		...state.payroll,
		expand: !department || (state.payroll.departmentExpanded && state.payroll.departmentExpanded[department.id]),
		...state.departments,
		employees,
		currency: state.company?.settings?.currency,
		isDemo: state.company?.settings?.isDemo,
		plan: state.company?.settings?.plan,
		employeesNotReady: employees?.filter?.(
			(employee) =>
				employee.employmentTypeName !== "External Contractor" &&
				!(
					employee.payslip?.ready &&
					(employee.payslip?.ready === true || employee.payslip?.ready?.toLowerCase?.() !== "no")
				) &&
				(!department || employee.department == department.id),
		).length,
		employeesNotProcessed: employees?.filter?.(
			(employee) =>
				employee.employmentTypeName !== "External Contractor" &&
				!(
					employee.payslip &&
					((employee.payslip?.ready &&
						(employee.payslip?.ready === true || employee.payslip?.ready?.toLowerCase?.() !== "no")) ||
						(employee.payslip.id &&
							employee?.payslip?.processedTimesheets &&
							(employee?.payslip?.processedTimesheets === true ||
								employee.payslip.processedTimesheets?.toLowerCase?.() == "yes")))
				) &&
				(!department || employee.department == department.id),
		).length,
		totalEmployees: employees?.filter?.(
			(employee) =>
				employee.employmentTypeName !== "External Contractor" &&
				(!department || employee.department == department.id),
		).length,
		generating:
			state.payroll &&
			state.payroll.generating &&
			state.payroll.generating[(department && department.id) || "all"],
		userEntersData,
		canProcessTimesheets: state.permissions?.plan?.processTimesheets,
		// ...state.employees,
	};
};

const mapDispatchToProps = (dispatch) => ({
	overtimeGetList: () => dispatch(OVERTIMEACTIONS.overtimeGetList()),
	allowanceGetList: () => dispatch(ALLOWANCEACTIONS.allowanceGetList()),
	payrollGetList: (payrunID) => dispatch(ACTIONS.payrollGetList(payrunID)),
	payrollPageToggle: (page) => dispatch(ACTIONS.payrollPageToggle(page)),
	setPayrollDepartmentExpanded: (department, expand) =>
		dispatch(ACTIONS.setPayrollDepartmentExpanded(department, expand)),
	payrollSaveAll: (department) => dispatch(ACTIONS.payrollSaveAll(department)),
	processTimesheets: (department) => dispatch(ACTIONS.processTimesheets(true, department)),
});

export default connect(mapStateToProps, mapDispatchToProps)(PayrollTable);
